export enum UserRole {
  Admin = 'admin',
  Moderator = 'moderator',
  SurveyOwner = 'survey_owner',
  Client = 'client',
}
